import request from './request';

// 获取执行记录列表（支持筛选和分页）
export function getExecutionLogs(params) {
  return request({
    url: '/execution-logs',
    method: 'get',
    params
  });
}

// 获取执行记录详情
export function getExecutionLogById(logId) {
  return request({
    url: `/execution-logs/${logId}`,
    method: 'get'
  });
}

